var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    clipRule: "nonzero",
    d: "M7.58638 0.102166C7.8199 -0.0340553 8.10867 -0.0340553 8.34219 0.102166L14.5565 3.72717C14.7869 3.86157 14.9286 4.10825 14.9286 4.375V11.625C14.9286 11.8918 14.7869 12.1384 14.5565 12.2728L8.34219 15.8978C8.10867 16.0341 7.8199 16.0341 7.58638 15.8978L1.3721 12.2728C1.14168 12.1384 1 11.8918 1 11.625V4.375C1 4.10825 1.14168 3.86157 1.3721 3.72717L7.58638 0.102166ZM7.96429 14.3817L13.4286 11.1942V4.80578L7.96429 1.61828L2.5 4.80578V11.1942L7.96429 14.3817Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    clipRule: "nonzero",
    d: "M8.00017 5.5C6.61936 5.5 5.5 6.61936 5.5 8.00017C5.5 9.38097 6.61936 10.5003 8.00017 10.5003C8.71226 10.5003 9.3538 10.2036 9.81009 9.725C10.0959 9.4252 10.5706 9.41386 10.8704 9.69968C11.1703 9.9855 11.1816 10.4602 10.8958 10.76C10.1682 11.5232 9.13926 12.0003 8.00017 12.0003C5.79094 12.0003 4 10.2094 4 8.00017C4 5.79094 5.79094 4 8.00017 4C9.13445 4 10.1595 4.47309 10.8866 5.23069C11.1734 5.52954 11.1636 6.00432 10.8648 6.29112C10.5659 6.57793 10.0911 6.56817 9.80433 6.26931C9.3484 5.79424 8.70928 5.5 8.00017 5.5Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.41e150f81c2b3ff7318e1821b6089676.svg";
export { ForwardRef as ReactComponent };